(function () {
  'use strict';

  const CONFIG = window.__FREE_GIFT_CONFIG || {};
  const TIERS = CONFIG.tiers || [];
  const CURRENCY_MULTIPLIER = CONFIG.currencyMultiplier || 100;
  const GIFT_PROPERTY_KEY = '_free_gift';
  const DEBOUNCE_MS = 600;

  let isProcessing = false;
  let selfTriggered = false;

  function getAllGiftVariantIds() {
    return TIERS.map(function (t) { return t.variantId; });
  }

  function getCartTotal(cart) {
    let total = 0;
    const giftIds = getAllGiftVariantIds();
    cart.items.forEach(function (item) {
      if (giftIds.indexOf(item.variant_id) === -1 && !(item.properties && item.properties[GIFT_PROPERTY_KEY])) {
        total += item.final_line_price;
      }
    });
    return total;
  }

  function getApplicableTier(totalInCents) {
    let matched = null;
    TIERS.forEach(function (tier) {
      if (totalInCents >= tier.minAmount * CURRENCY_MULTIPLIER) {
        if (!matched || tier.minAmount > matched.minAmount) {
          matched = tier;
        }
      }
    });
    return matched;
  }

  function getCurrentGiftItems(cart) {
    const giftIds = getAllGiftVariantIds();
    return cart.items.filter(function (item) {
      return giftIds.indexOf(item.variant_id) !== -1 || (item.properties && item.properties[GIFT_PROPERTY_KEY]);
    });
  }

  function giftFetch(url, options) {
    selfTriggered = true;
    return fetch(url, options).then(function (r) {
      selfTriggered = false;
      return r.json();
    }).catch(function (err) {
      selfTriggered = false;
      throw err;
    });
  }

  function fetchCart() {
    return giftFetch('/cart.js', {
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' }
    });
  }

  function addItem(variantId) {
    return giftFetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{
          id: variantId,
          quantity: 1,
          properties: { [GIFT_PROPERTY_KEY]: 'true' }
        }]
      })
    });
  }

  function removeItemByKey(key) {
    return giftFetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    });
  }

  function removeItems(giftItems) {
    return giftItems.reduce(function (chain, item) {
      return chain.then(function () { return removeItemByKey(item.key); });
    }, Promise.resolve());
  }

  function processGifts() {
    if (isProcessing) return;
    isProcessing = true;

    fetchCart()
      .then(function (cart) {
        const total = getCartTotal(cart);
        const tier = getApplicableTier(total);
        const currentGifts = getCurrentGiftItems(cart);

        if (cart.item_count === 0 || (cart.item_count === currentGifts.length)) {
          if (currentGifts.length > 0) {
            return removeItems(currentGifts)
              .then(function () { refreshPage(); });
          }
          return;
        }

        if (!tier) {
          if (currentGifts.length > 0) {
            return removeItems(currentGifts)
              .then(function () { refreshPage(); });
          }
          return;
        }

        const wrongGifts = currentGifts.filter(function (g) {
          return g.variant_id !== tier.variantId;
        });
        const hasCorrectGift = currentGifts.some(function (g) {
          return g.variant_id === tier.variantId;
        });

        if (wrongGifts.length > 0) {
          return removeItems(wrongGifts)
            .then(function () {
              if (!hasCorrectGift) {
                return addItem(tier.variantId);
              }
            })
            .then(function () { refreshPage(); });
        }

        if (!hasCorrectGift) {
          return addItem(tier.variantId)
            .then(function () { refreshPage(); });
        }
      })
      .catch(function (err) {
        console.error('[Free Gift Hamper]', err);
      })
      .then(function () {
        isProcessing = false;
      });
  }

  function refreshPage() {
    if (window.location.pathname === '/cart') {
      window.location.reload();
    } else {
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    }
  }

  let debounceTimer;
  function debouncedProcess() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(processGifts, DEBOUNCE_MS);
  }

  function interceptFetch() {
    const originalFetch = window.fetch;
    window.fetch = function () {
      var args = arguments;
      var url = args[0];
      var urlStr = typeof url === 'string' ? url : (url && url.url ? url.url : '');

      if (selfTriggered) {
        return originalFetch.apply(this, args);
      }

      return originalFetch.apply(this, args).then(function (response) {
        if (urlStr.match(/\/cart\/(add|change|update|clear)\.js/)) {
          debouncedProcess();
        }
        return response;
      });
    };
  }

  function interceptXHR() {
    var originalOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      this._url = url;
      return originalOpen.apply(this, arguments);
    };

    var originalSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function () {
      var xhr = this;
      xhr.addEventListener('load', function () {
        if (!selfTriggered && xhr._url && xhr._url.match(/\/cart\/(add|change|update|clear)\.js/)) {
          debouncedProcess();
        }
      });
      return originalSend.apply(this, arguments);
    };
  }

  function init() {
    if (TIERS.length === 0) {
      console.warn('[Free Gift Hamper] No tiers configured. Please set window.__FREE_GIFT_CONFIG.');
      return;
    }

    interceptFetch();
    interceptXHR();
    processGifts();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();